/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  TextField,
  TextAreaField,
  SelectField,
  Text,
  View,
} from "@aws-amplify/ui-react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Leads } from "../models";
import { fetchByPath, validateField } from "../utils/validation";
import { optionDiscarded } from "../utils/optionDiscarded";
import { DataStore } from "aws-amplify";
import Swal from "sweetalert2";
import { useContext, useEffect } from "react";
import LeadsContext from "../context/leads";
import moment from "moment";


export default function LeadsCreateForm(props) {
  const optionsDiscarded = optionDiscarded;
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    onToggleTab,
    user,
    userName,
    ...rest
  } = props;

  let date = new Date();
  const dateRegister = moment(date,"DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm")

  const initialValues = {
    name: "",
    firstLastName: "",
    secondLastName: "",
    birth: "",
    adress: "",
    cp: "",
    suburb: "",
    municipio: "",
    estado: "",
    pais: "",
    phone1: "",
    email: "",
    curp: "",
    comments: "",
    channel: "Contact Center",
    dateRegistry: `${dateRegister}`,
    idBranch: "",
    branch: "",
    detail: "",
    Who: `${user}`,
    conekta: `${userName}`,
    dateManager: "",
    fase: "",
    CommentManage: "",
    idManager: "",
    NameManager: "",
    dateAsignation: "",
    status: 0,
    idAdvicer: "",
    advicer: "",
    dateAtencion: "",
    isContacted: "",
    idEvent: "",
  };
  const [name, setName] = React.useState(initialValues.name);
  const [firstLastName, setFirstLastName] = React.useState(
    initialValues.firstLastName
  );
  const [secondLastName, setSecondLastName] = React.useState(
    initialValues.secondLastName
  );
  const [phone1, setPhone1] = React.useState(initialValues.phone1);
  const [birth, setBirth] = React.useState(initialValues.birth);
  const [cp, setCp] = React.useState(initialValues.cp);
  const [suburb, setSuburb] = React.useState(initialValues.suburb);
  const [other, setOther] = React.useState(initialValues.suburb);
  const [adress, setAdress] = React.useState(initialValues.adress);
  const [municipio, setMunicipio] = React.useState(initialValues.municipio);
  const [estado, setEstado] = React.useState(initialValues.estado);
  const [pais, setPais] = React.useState(initialValues.pais);

  const [curp, setCurp] = React.useState(initialValues.curp);
  const [email, setEmail] = React.useState(initialValues.email);
  const [dateRegistry, setDateRegistry] = React.useState(
    initialValues.dateRegistry
  );
  const [channel, setChannel] = React.useState(initialValues.channel);
  const [conekta, setConekta] = React.useState(initialValues.conekta);
  const [comments, setComments] = React.useState(initialValues.comments);
  const [idBranch, setIdBranch] = React.useState(initialValues.idBranch);
  const [branch, setBranch] = React.useState(initialValues.branch);
  const [CommentManage, setCommentManage] = React.useState(
    initialValues.CommentManage
  );
  const [detail, setDetail] = React.useState(initialValues.detail);
  const [Who, setWho] = React.useState(initialValues.Who);
  const [dateAsignation, setDateAsignation] = React.useState(
    initialValues.dateAsignation
  );
  const [dateManager, setDateManager] = React.useState(
    initialValues.dateManager
  );
  const [fase, setFase] = React.useState(initialValues.fase);
  const [NameManager, setNameManager] = React.useState(
    initialValues.NameManager
  );
  const [idAdvicer, setIdAdvicer] = React.useState(initialValues.idAdvicer);
  const [advicer, setAdvicer] = React.useState(initialValues.advicer);
  const [idManager, setIdManager] = React.useState(initialValues.idManager);
  const [status, setStatus] = React.useState(initialValues.status);
  const [dateAtencion, setDateAtencion] = React.useState(
    initialValues.dateAtencion
  );
  const [isContacted, setIsContacted] = React.useState(
    initialValues.isContacted
  );
  const [idEvent, setIdEvent] = React.useState(initialValues.idEvent);
  const [errors, setErrors] = React.useState({});

  const ShowAlert = () => {
    if (optBranch[0]?.id === undefined) {
      Swal.fire({
        icon: "warning",
        text: "Por el momento, no hay una sucursal cercana",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#272D5D",
      }).then((result) => {
        if (result.isConfirmed) {
          onToggleTab(1);
        }
      });
    } else if (status == 1) {
      Swal.fire({
        icon: "success",
        text: "El lead se ha creado y asignado con exito",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#272D5D",
      }).then((result) => {
        if (result.isConfirmed) {
          onToggleTab(1);
        }
      });
    } else {
      Swal.fire({
        icon: "success",
        text: "El lead se ha creado con exito",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#272D5D",
      }).then((result) => {
        if (result.isConfirmed) {
          onToggleTab(1);
        }
      });
    }
  };
  const resetStateValues = () => {
    setOptZip([]);
    setOptBranch([]);
    setObtAdress([]);
    setName(initialValues.name);
    setFirstLastName(initialValues.firstLastName);
    setSecondLastName(initialValues.secondLastName);
    setPhone1(initialValues.phone1);
    setPhone2(initialValues.phone2);
    setPhone3(initialValues.phone3);
    setBirth(initialValues.birth);
    setCp(initialValues.cp);
    setAdress(initialValues.adress);
    setSuburb(initialValues.suburb);
    setCalle(initialValues.calle);
    setInterior(initialValues.interior);
    setExterior(initialValues.exterior);
    setMunicipio(initialValues.municipio);
    setEstado(initialValues.estado);
    setPais(initialValues.pais);
    setCurp(initialValues.curp);
    setEmail(initialValues.email);
    setDateRegistry(initialValues.dateRegistry);
    setChannel(initialValues.channel);
    setConekta(initialValues.conekta);
    setComments(initialValues.comments);
    setIdBranch(initialValues.idBranch);
    setBranch(initialValues.branch);
    setCommentManage(initialValues.CommentManage);
    setDetail(initialValues.detail);
    setWho(initialValues.Who);
    setDateAsignation(initialValues.dateAsignation);
    setDateManager(initialValues.dateManager);
    setFase(initialValues.fase);
    setNameManager(initialValues.NameManager);
    setIdAdvicer(initialValues.idAdvicer);
    setAdvicer(initialValues.advicer);
    setIdManager(initialValues.idManager);
    setStatus(initialValues.status);
    setDateAtencion(initialValues.dateAtencion);
    setIsContacted(initialValues.isContacted);
    setIdEvent(initialValues.idEvent);
    setErrors({});
  };
  const validations = {
    name: [{ type: "Required" }],
    firstLastName: [{ type: "Required" }],
    secondLastName: [],
    phone1: [{ type: "Required" }, { type: "Phone" }],
    birth: [],
    curp: [],
    email: [{ type: "Email" }],
    dateRegistry: [],
    channel: [],
    conekta: [],
    comments: [],
    idBranch: [],
    branch: [],
    CommentManage: [],
    detail: [],
    Who: [],
    dateAsignation: [],
    dateManager: [],
    fase: [],
    NameManager: [],
    idAdvicer: [],
    advicer: [],
    idManager: [],
    status: [],
    dateAtencion: [],
    isContacted: [],
    idEvent: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value = getDisplayValue
      ? getDisplayValue(currentValue)
      : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };

  const {
    optZip,
    setOptZip,
    optBranch,
    setOptBranch,
    obtainSuburb,
    obtainBranch,
    getAdress,
    obtAdress,
    setObtAdress,
  } = useContext(LeadsContext);

  useEffect(() => {
    obtainBranch(cp);
    obtainSuburb(cp);
  }, [cp]);

  useEffect(() => {
    getAdress(suburb);
  }, [suburb]);

  //console.log()

  return (
    <Grid
      as="form"
      rowGap="32px"
      columnGap="24px"
      templateColumns={{
        base: "1fr",
        small: "1fr",
        medium: "1fr 1fr 1fr",
      }}
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          name,
          firstLastName,
          secondLastName,
          birth,
          adress: `{\n   "cp":"${cp}",\n   "asentamiento":"${
            suburb === "otra" ? other : suburb
          }",\n   "municipio":"${obtAdress?.municipio}",\n   "estado":"${
            obtAdress?.estado
          }",\n   "pais":"${obtAdress?.pais}"\n}`,
          phone1,
          email,
          curp,
          comments,
          channel,
          dateRegistry,
          idBranch: status == 1 ? optBranch[0]?.id : idBranch,
          branch: status == 1 ? optBranch[0]?.branchOfficeName : branch,
          detail,
          Who,
          conekta,
          dateManager,
          fase,
          CommentManage,
          idManager,
          NameManager,
          dateAsignation: status == 1 ? dateRegister : dateAsignation,
          status:
            status == 1 && optBranch[0]?.id === undefined
              ? 7
              : parseInt(status),
          idAdvicer,
          advicer,
          dateAtencion,
          isContacted,
          idEvent,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value.trim() === "") {
              modelFields[key] = undefined;
            }
          });
          await DataStore.save(new Leads(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            ShowAlert();
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "LeadsCreateForm")}
      {...rest}
    >
      <TextField
        label="Nombre"
        variation="quiet"
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name: value,
              firstLastName,
              secondLastName,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <TextField
        label="Apellido paterno"
        variation="quiet"
        isRequired={true}
        isReadOnly={false}
        value={firstLastName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName: value,
              secondLastName,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.firstLastName ?? value;
          }
          if (errors.firstLastName?.hasError) {
            runValidationTasks("firstLastName", value);
          }
          setFirstLastName(value);
        }}
        onBlur={() => runValidationTasks("firstLastName", firstLastName)}
        errorMessage={errors.firstLastName?.errorMessage}
        hasError={errors.firstLastName?.hasError}
        {...getOverrideProps(overrides, "firstLastName")}
      ></TextField>
      <TextField
        label="Apellido materno"
        variation="quiet"
        isRequired={false}
        isReadOnly={false}
        value={secondLastName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName: value,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.secondLastName ?? value;
          }
          if (errors.secondLastName?.hasError) {
            runValidationTasks("secondLastName", value);
          }
          setSecondLastName(value);
        }}
        onBlur={() => runValidationTasks("secondLastName", secondLastName)}
        errorMessage={errors.secondLastName?.errorMessage}
        hasError={errors.secondLastName?.hasError}
        {...getOverrideProps(overrides, "secondLastName")}
      ></TextField>
      <TextField
        label="Fecha de nacimiento"
        variation="quiet"
        isRequired={false}
        isReadOnly={false}
        type="date"
        value={birth}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth: value,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.birth ?? value;
          }
          if (errors.birth?.hasError) {
            runValidationTasks("birth", value);
          }
          setBirth(value);
        }}
        onBlur={() => runValidationTasks("birth", birth)}
        errorMessage={errors.birth?.errorMessage}
        hasError={errors.birth?.hasError}
        {...getOverrideProps(overrides, "birth")}
      ></TextField>
      <TextField
        label="Código postal"
        variation="quiet"
        isRequired={false}
        isReadOnly={false}
        value={cp}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              adress: `'{"cp":"${value}", "asentamiento":"", "municipio":"","estado":"", "pais":""}'`,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
            };
            const result = onChange(modelFields);
            value = result?.cp ?? value;
          }
          if (errors.cp?.hasError) {
            runValidationTasks("cp", value);
          }
          setCp(value);
        }}
        onBlur={() => runValidationTasks("cp", cp)}
        errorMessage={errors.cp?.errorMessage}
        hasError={errors.cp?.hasError}
        {...getOverrideProps(overrides, "cp")}
      ></TextField>
      <SelectField
        label="Colonia"
        isRequired={false}
        placeholder="Seleccionar"
        value={suburb}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.suburb ?? value;
          }
          if (errors.suburb?.hasError) {
            runValidationTasks("suburb", value);
          }
          setSuburb(value);
        }}
        onBlur={() => runValidationTasks("suburb", suburb)}
        errorMessage={errors.suburb?.errorMessage}
        hasError={errors.suburb?.hasError}
        {...getOverrideProps(overrides, "suburb")}
      >
        {optZip?.map((option) => (
          <option key={option.id} value={option.asentamiento}>
            {option.asentamiento}
          </option>
        ))}
        <option value="otra">Otra</option>
      </SelectField>
      {suburb === "otra" && (
        <TextField
          label="Otra colonia"
          variation="quiet"
          isRequired={false}
          isReadOnly={false}
          value={other}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.other ?? value;
            }
            setOther(value);
          }}
        ></TextField>
      )}
      <TextField
        label="Teléfono de contacto"
        variation="quiet"
        isRequired={true}
        isReadOnly={false}
        type="tel"
        value={phone1}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              phone1: value,
              email,
              curp,
              comments,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.phone1 ?? value;
          }
          if (errors.phone1?.hasError) {
            runValidationTasks("phone1", value);
          }
          setPhone1(value);
        }}
        onBlur={() => runValidationTasks("phone1", phone1)}
        errorMessage={errors.phone1?.errorMessage}
        hasError={errors.phone1?.hasError}
        {...getOverrideProps(overrides, "phone1")}
      ></TextField>

      <View>
        <TextField
          label="CURP"
          isRequired={false}
          variation="quiet"
          isReadOnly={false}
          value={curp}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp: value,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.curp ?? value;
            }
            if (errors.curp?.hasError) {
              runValidationTasks("curp", value);
            }
            setCurp(value);
          }}
          onBlur={() => runValidationTasks("curp", curp)}
          errorMessage={errors.curp?.errorMessage}
          hasError={errors.curp?.hasError}
          {...getOverrideProps(overrides, "curp")}
        ></TextField>
        <Text
          margin="0.3rem"
          fontSize="0.8em"
          color="#5C6670"
          fontStyle="italic"
        >
          Opcional
        </Text>
      </View>
      <View>
        <TextField
          label="Correo electrónico"
          variation="quiet"
          isRequired={false}
          isReadOnly={false}
          value={email}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email: value,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.email ?? value;
            }
            if (errors.email?.hasError) {
              runValidationTasks("email", value);
            }
            setEmail(value);
          }}
          onBlur={() => runValidationTasks("email", email)}
          errorMessage={errors.email?.errorMessage}
          hasError={errors.email?.hasError}
          {...getOverrideProps(overrides, "email")}
        ></TextField>
        <Text
          margin="0.3rem"
          fontSize="0.8em"
          color="#5C6670"
          fontStyle="italic"
        >
          Opcional
        </Text>
      </View>
      <View columnStart="1" columnEnd="2">
        <SelectField
          label="Acción"
          placeholder="Seleccionar"
          isRequired={false}
          value={status}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status: value,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.status ?? value;
            }
            if (errors.status?.hasError) {
              runValidationTasks("status", value);
            }
            setStatus(value);
          }}
          onBlur={() => runValidationTasks("status", status)}
          errorMessage={errors.status?.errorMessage}
          hasError={errors.status?.hasError}
          {...getOverrideProps(overrides, "status")}
        >
          <option value={1}>Asignar</option>
          <option value={2}>Descartar</option>
        </SelectField>
      </View>
      <View>
        <SelectField
          label="Detalle"
          placeholder="Seleccionar"
          isRequired={false}
          isDisabled={status == 2 ? false : true}
          value={detail}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                name,
                firstLastName,
                secondLastName,
                birth,
                adress,
                phone1,
                email,
                curp,
                comments,
                channel,
                dateRegistry,
                idBranch,
                branch,
                detail: value,
                Who,
                conekta,
                dateManager,
                fase,
                CommentManage,
                idManager,
                NameManager,
                dateAsignation,
                status,
                idAdvicer,
                advicer,
                dateAtencion,
                isContacted,
                idEvent,
              };
              const result = onChange(modelFields);
              value = result?.detail ?? value;
            }
            if (errors.detail?.hasError) {
              runValidationTasks("detail", value);
            }
            setDetail(value);
          }}
          onBlur={() => runValidationTasks("detail", detail)}
          errorMessage={errors.detail?.errorMessage}
          hasError={errors.detail?.hasError}
          {...getOverrideProps(overrides, "detail")}
        >
          {optionsDiscarded.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </SelectField>
      </View>
      <TextAreaField
        label="Comentarios"
        columnStart={{ base: "1", small: "3" }}
        columnEnd="-1"
        variation="quiet"
        isRequired={false}
        isReadOnly={false}
        value={comments}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              name,
              firstLastName,
              secondLastName,
              birth,
              adress,
              phone1,
              email,
              curp,
              comments: value,
              channel,
              dateRegistry,
              idBranch,
              branch,
              detail,
              Who,
              conekta,
              dateManager,
              fase,
              CommentManage,
              idManager,
              NameManager,
              dateAsignation,
              status,
              idAdvicer,
              advicer,
              dateAtencion,
              isContacted,
              idEvent,
            };
            const result = onChange(modelFields);
            value = result?.comments ?? value;
          }
          if (errors.comments?.hasError) {
            runValidationTasks("comments", value);
          }
          setComments(value);
        }}
        onBlur={() => runValidationTasks("comments", comments)}
        errorMessage={errors.comments?.errorMessage}
        hasError={errors.comments?.hasError}
        {...getOverrideProps(overrides, "comments")}
      ></TextAreaField>

      <Flex
        justifyContent="end"
        columnStart="1"
        columnEnd="-1"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Limpiar"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Guardar"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
